var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinialFindingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.9097V4.99998C20 2.23857 17.7614 0 15 0C12.2386 0 10 2.23857 10 4.99998V16.9097C8.46563 18.283 7.5 20.2788 7.5 22.5C7.5 26.6422 10.8579 30 15 30C19.1421 30 22.5 26.6422 22.5 22.5C22.5 20.2788 21.5344 18.283 20 16.9097ZM15 27.5C12.2386 27.5 10 25.2614 10 22.5C10 21.0564 10.6118 19.7173 11.6673 18.7726L12.5 18.0272V4.99998C12.5 3.61928 13.6194 2.49996 15.0001 2.49996C16.3808 2.49996 17.5001 3.61922 17.5001 4.99998V18.0272L18.3328 18.7726C19.3883 19.7173 20.0001 21.0564 20.0001 22.5C20 25.2614 17.7614 27.5 15 27.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2501 10H13.7501V25H16.2501V10Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 26.2499C17.0712 26.2499 18.7501 24.5709 18.7501 22.4999C18.7501 20.4288 17.0712 18.7499 15.0001 18.7499C12.9291 18.7499 11.2501 20.4288 11.2501 22.4999C11.2501 24.5709 12.9291 26.2499 15.0001 26.2499Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinialFindingsIcon);
export default __webpack_public_path__ + "static/media/clinialFindingsIcon.84c20145ecfd6e4f9c5989fef37c7bdf.svg";
export { ForwardRef as ReactComponent };